;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.SidebarBuilder = Model.SidebarBuilder.extend({
		defaults: {
			widgets: [ 'MenuSideBar' , 'Promo'],
			menuItems: [
				{ name: 'Tipping Game Guidelines', url: 'help/game-guidelines', status: ''},
				{ name: 'Tipping FAQs', url: 'help/faqs', status: ''},
				{ name: 'Terms and Conditions', url: 'help/terms', status: ''},
				{ name: 'Prizes', url: 'help/prizes', status: ''},
				{ name: 'Contact Us', url: 'help/contact-us', status: ''}
			]
		},

		setMenuItems: function() {
			var route_name = CONFIG.OFF_SEASON ? 'off-season/' : '',
				menu_items = [
					{ name: 'Tipping Game Guidelines', url: route_name + 'help/game-guidelines', status: ''},
					{ name: 'Tipping FAQs', url: route_name + 'help/faqs', status: ''},,
					{ name: 'Terms and Conditions', url: route_name + 'help/terms', status: ''},
					{ name: 'Prizes', url: route_name + 'help/prizes', status: ''},
					{ name: 'Contact Us', url: route_name + 'help/contact-us', status: ''}
				];

			if (CONFIG.OFF_SEASON) {
				menu_items.pop();
			}

			if (CONFIG.OFF_SEASON) {
				this.set('menuItems', menu_items);
			}

			return this;
		},

		initialize: function(){
			this.setMenuItems()
				.setActiveState();
			APP.help_started = false;
		}
	});

}(window, APP, Backbone, Marionette, $, _));